import DOMPurify from 'dompurify'

/**
 * 用户输入的富文本内容清洗（XSS 防护）
 *
 * 背景：管理后台会展示 C 端用户或运营填写的内容（订单内容描述、公告正文等）。
 * 这些内容若未经清洗直接用 v-html 渲染，攻击者可在下单/发布公告时植入脚本，
 * 脚本会以管理员权限执行，从而窃取后台登录凭证、伪造操作。
 *
 * 要求：任何 v-html 渲染用户内容之前，必须先经过本方法。
 */
export function sanitizeRichText (html) {
  if (!html) {
    return ''
  }
  return DOMPurify.sanitize(html)
}

export default sanitizeRichText
